import {
	MERCHANT_PROFILE_REQUESTING,
	MERCHANT_PROFILE_SUCCESS,
	MERCHANT_PROFILE_ERROR,
	MERCHANT_LIST_REQUESTING,
	MERCHANT_LIST_SUCCESS,
	MERCHANT_LIST_ERROR,
	SAVE_MERCHANT_INFO,
	UPDATE_USER_PROFILE_REQUESTING,
	UPDATE_USER_PROFILE_SUCCESS,
	UPDATE_USER_PROFILE_ERROR,
	SAVE_MERCHANT_ONBOARDING_INFO,
	SET_MERCHANT_FEATURE_CONFIG,
	UPDATE_PAYLINK_FEATURE_CONFIG,
} from './types';

export const initialState = {
	loading: false,
	merchantDetails: {},
	paymentOptions: {},
	merchantList: [],
	onboardingInfo: {},
	featureConfig: {
		paylink: {
			apiEnabled: false,
			blocked: false,
			dashboardEnabled: false,
		},
		webhook: {
			dashboardEnabled: false,
			webhookConfigured: false,
		},
	},
};

function getMerchantDetails(state = initialState, action) {
	switch (action.type) {
		case MERCHANT_PROFILE_REQUESTING:
		case MERCHANT_LIST_REQUESTING:
		case UPDATE_USER_PROFILE_REQUESTING:
			return {
				...state,
				loading: true,
			};
		case MERCHANT_PROFILE_SUCCESS:
			return {
				...state,
				loading: false,
				merchantDetails: action.data,
				error: undefined,
			};
		case MERCHANT_PROFILE_ERROR:
			return {
				...state,
				loading: false,
				error: action.error,
				merchantDetails: {},
			};
		case MERCHANT_LIST_SUCCESS:
			return {
				...state,
				merchantList: action.data,
				loading: false,
			};
		case MERCHANT_LIST_ERROR:
			return {
				...state,
				loading: false,
				error: action.error,
				merchantList: [],
			};
		case SAVE_MERCHANT_INFO:
			return {
				...state,
				merchantList: action.merchantList,
				merchantDetails: action.merchantProfile,
			};
		case UPDATE_USER_PROFILE_SUCCESS:
		case UPDATE_USER_PROFILE_ERROR:
			return {
				...state,
				loading: false,
			};
		case SAVE_MERCHANT_ONBOARDING_INFO:
			return {
				...state,
				onboardingInfo: action.data,
			};
		case SET_MERCHANT_FEATURE_CONFIG:
			return {
				...state,
				featureConfig: action.data,
			};
		case UPDATE_PAYLINK_FEATURE_CONFIG:
			return {
				...state,
				featureConfig: {
					...state.featureConfig,
					paylink: action.payload,
				},
			};
		default:
			return state;
	}
}

export default getMerchantDetails;
